<template>
  <div
    :class="{ 'no-border': item.text.length === 0, 'has-bg': item.hasBg }"
    @click="$emit('select-schedule', { item })"
  >
    <span>{{ item.text }}</span>
  </div>
</template>

<script>
export default {
  meta: {
    description: 'Componente común, elementos en el calendario.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return { text: '' };
      },
      meta: {
        description: 'Establece los elementos en el calendario',
        example: '{ key1: value1, key2: value2 }',
      },
    },
  },
};
</script>

<style>
.mipe-calendar-column section div {
  width: 100%;
  height: 65px;
  font-weight: 100;
  border-bottom: 1px solid #e2e2e2;

  padding-top: 20px;
}
.mipe-calendar-column section div:hover:not(.no-border):not(.no-available) {
  background: #2db782;
  border: 1px solid #2db782;
  color: white;
  cursor: pointer;
}
.mipe-calendar-column section div.no-border {
  border-bottom: none;
}
.has-bg {
  background-color: #FDE9E5;
}
</style>
